export const sizes = {
    padding: {
        lg: '1rem',
        xs: '0.5rem',
    },
    font: {
        small: '0.7rem',
        normal: '1rem',
        medium: '1.25rem',
        large: '2rem',
        big: '3.5rem',
    },
};

export const colors = {
    primary: '#48484F',
    blue: '#91b1da',
    primaryText: '#FFF',
    secondaryText: '#48484F',
    bgGradient: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
};

export const breakpoints = {
    xs: '@media (min-width:320px)',
    sm: '@media (min-width: 576px)',
    md: '@media (min-width: 768px)',
    lg: '@media (min-width: 992px)',
    xl: '@media (min-width: 1200px)',
    xxl: '@media(min-width: 1440px)',
};

export const aqiColors = {
    good: '#009b6b',
    moderate: '#ffdc55',
    unhealthySensitive: '#ff9446',
    unhealthy: '#DD0034',
    veryUnhealthy: '#6d0093',
    hazardous: '#890023',
};
